// extracted by mini-css-extract-plugin
export var logoSVG = "Logo-module--logoSVG--49739";